import { texts } from '@/lib/texts';

const botUrl = import.meta.env.VITE_BOT_URL;

/**
 * Production вне Telegram: SDK не инициализируем, показываем инструкцию. Сюда же попадает
 * клиент, у которого SDK не поднялся: текст ошибки виден на экране, иначе человек смотрит в
 * пустоту и сказать о поломке ему нечего.
 */
export function NotInTelegramScreen({ error }: { error?: string }) {
  return (
    <main className="bg-bg text-fg flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
      <h1 className="text-2xl font-bold tracking-tight">{texts.gate.notInTelegramTitle}</h1>
      <p className="text-muted max-w-xs text-base">{texts.gate.notInTelegramBody}</p>
      {botUrl ? (
        <a
          href={botUrl}
          className="bg-accent text-accent-fg mt-2 rounded-xl px-6 py-3 font-semibold"
        >
          {texts.gate.openBot}
        </a>
      ) : null}
      {error ? (
        <p className="text-muted mt-4 max-w-xs font-mono text-xs break-words">{error}</p>
      ) : null}
    </main>
  );
}
